import axios from '../http'

const article = {
  getScreenMenuRules: () => axios.get('/api/screen/menuScheduleRules', { silent: true }),
  getScreenMenuScheduleStatus: () => axios.post('/store/dishes.pushRule/aiPushStatus', '', { withCredentials: true, silent: true }),
  saveScreenMenuSchedule: (fields) => axios.post('/api/screen/menuSchedulePush',
    Object.keys(fields).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(fields[key])}`).join('&'),
    { withCredentials: true, silent: true }),
  getWmsSso: () => axios.post('/api/screen/wmsLogin', 'refresh_if_needed=1', { silent: true }),
  getNutritionTrackerAnalysis: (params) => axios.get('/api/screen/dietaryStaffAnalysis', { params, withCredentials: true, silent: true }),
  getNutritionTrackerPanel: (endpoint, params) => axios.post('/p/Ontoanalysis/' + endpoint,
    Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&'),
    { withCredentials: true, silent: true }),
  // 内网大屏专用只读接口；后台接口继续要求登录。
  getDietaryStaffInfo: (params) => axios.get('/api/screen/dietaryStaffInfo', { params, silent: true }),
  getDietaryDepartments: (params) => axios.get('/api/screen/dietaryDepartments', { params, silent: true }),
  getDietaryMonitor: (params) => axios.get('/api/screen/dietaryMonitor', { params, silent: true }),
  // 进程停止
  reloadWorker: (parmes) => {
    return axios.post('/worker/ReloadWorker/reloadWorker', {
      ...parmes
    })
  },
  // 获取人员信息
  getStaffInfo: (parmes) => {
    return axios.post('/p/staff/getStaffInfo', {
      ...parmes
    })
  },
  screenData: (parmes) => {
    return axios.post('/p/venue/screenData', {
      ...parmes
    })
  },
  screenVenueInfo: (parmes) => {
    return axios.post('/p/Venue/getStaffInfo', {
      ...parmes
    })
  },
  getDeviceData: (parmes) => {
    return axios.post('/p/venue/getDeviceData', {
      ...parmes
    })
  },
  getScreenInfo: (parmes) => {
    return axios.post('/p/venue/getScreenInfo', {
      ...parmes
    })
  },
  getSurplusBoard: (parmes) => {
    return axios.post('/api/screen/surplusBoard', {
      ...parmes
    })
  },
  // 叫号大屏
  getPickupQueue: (parmes) => {
    return axios.get('/api/orderMachine/pickupQueue', {
      params: {
        ...parmes
      }
    })
  },
  // 运营看板数据
  getOperation: (parmes) => {
    return axios.post('/api/screen/operation', {
      ...parmes
    })
  },
  // 无需登录的终端品牌 Logo 配置
  getBrandLogoConfig: (terminal) => {
    return axios.get('/api/brandLogo/config', {
      params: { terminal },
      silent: true
    })
  },
  // 安徽项目智慧食堂周菜谱大屏
  getAnhuiCanteenBoard: (parmes) => {
    return axios.get('/api/screen/anhuiBoard', {
      params: {
        ...parmes
      }
    })
  },
  // 安徽项目智慧食堂大屏人员名单
  getAnhuiCanteenStaffNames: (parmes) => {
    return axios.get('/api/screen/anhuiStaffNames', {
      params: {
        ...parmes
      }
    })
  },
  // 全国项目数据中心
  getDataCenterDashboard: (parmes) => {
    return axios.get('/api/dataCenterDashboard', {
      params: {
        ...parmes
      }
    })
  },
  getOneMenu: (parmes) => {
    return axios.post('/m/ControlScreen/everyMealSupply', {
      ...parmes
    })
  },
  getOneMenuSch: (parmes) => {
    return axios.post('/m/ControlScreen/everyMealSupplySch', {
      ...parmes
    })
  },
  getTwoMenu: (parmes) => {
    return axios.post('/m/ControlScreen/cuisineKind', {
      ...parmes
    })
  },
  getThreeMenu: (parmes) => {
    return axios.post('/m/ControlScreen/offerIngredient', {
      ...parmes
    })
  },
  getfoveMenu: (parmes) => {
    return axios.post('/m/ControlScreen/recommend', {
      ...parmes
    })
  },
  getfoveMenu_v1: (parmes) => {
    return axios.post('/m/ControlScreen/recommend_v1', {
      ...parmes
    })
  },

  getFooter: (parmes) => {
    return axios.post('/m/ControlScreen/talkAbout', {
      ...parmes
    })
  },

  restaurantMenu:()=>{
    return axios.post('/p/Restaurant/restaurant_name')
  }
}

export default article



// WEBPACK FOOTER //
// ./src/request/api/article.js